var map = {
	"./Bixi.png": 18608,
	"./Elephant.png": 53221,
	"./Fire Horse.png": 97089,
	"./Hedgehog.png": 658,
	"./Huye.png": 63802,
	"./Jiaotu.png": 10735,
	"./Kamaja.png": 31699,
	"./Kirin.png": 94509,
	"./Phoenix.png": 22982,
	"./Shishi.png": 90490,
	"./Spring cattle.png": 10801,
	"./Suanni.png": 51656,
	"./Sword Lion.png": 80017,
	"./bat.png": 51133,
	"./dragon.png": 5354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27722;